import { productBus } from "@/event/product/productBus"
import { relatedGroupBus } from "@/event/product/relatedGroupeBus"
import { selectOptionsListHappy } from "@/happyTheme/event/product/selectOptionsListHappy"
import type { Option } from "@/storage/products"
import type { Ref } from "vue"

export function incrementRadioHappy(optionValueId: number, option: Option, counterOptionValue: Ref<number>) {
    const maxQuantity = 1
    const optionId = option.option_id

    if (counterOptionValue.value >= maxQuantity && productBus.value?.options) {
        return
    }

    const optionFound = productBus.value?.options.find((e) => e.option_id === optionId)
    if (!optionFound) return

    const freeOptionCount = optionFound.free_option_count || 0
    const maxOptionCount = optionFound.max_option_count || 0

    const optionValueFind = optionFound?.values.find(
        (e) => e.option_value_id === optionValueId
    )
    if (!optionValueFind) return

    counterOptionValue.value++
    selectOptionsListHappy.value[optionId].selected_values.checkbox_option = {
        option_value_free: [],
        option_value_paid: [],
        quantity_free: freeOptionCount || 0,
        quantity_paid: Math.max(0, maxOptionCount - freeOptionCount)
    }

    const currentOptionAdded = {
        option_value_id: optionValueFind.option_value_id,
        option_value_image: optionValueFind.image,
        option_value_name: optionValueFind.language[2].name,
        option_value_price: optionValueFind.ov_price
    }

    selectOptionsListHappy.value[optionId].selected_values.radio_option =
        currentOptionAdded

    optionFound.values.forEach((oF) => {
        if (oF.related_option_id.length === 0) return
        oF.related_option_id.forEach((roi) => {
            if (!relatedGroupBus.value.includes(roi)) {
                relatedGroupBus.value.push(roi)
            }
        })
    })

    if (optionValueFind.related_option_id.length !== 0) {
        optionValueFind.related_option_id.forEach((roi) => {
            const idx = relatedGroupBus.value.indexOf(roi)
            if (idx !== -1) {
                relatedGroupBus.value.splice(idx, 1)
            }
        })
    }
}